import React, { useRef, useMemo } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Modal, Box } from "@mui/material";
import VideoFile1 from "../../assets/surveySlider/IMG_0705.MOV";
import VideoFile2 from "../../assets/surveySlider/IMG_0719.MOV";
import VideoFile3 from "../../assets/surveySlider/IMG_0728.MOV";
import VideoFile4 from "../../assets/surveySlider/IMG_0733.MOV";
import VideoFile5 from "../../assets/surveySlider/IMG_0734.MOV";
import VideoFile6 from "../../assets/surveySlider/IMG_0735.MOV";
import VideoFile7 from "../../assets/surveySlider/IMG_0737.MOV";
import VideoFile8 from "../../assets/surveySlider/IMG_0738.MOV";
import VideoFile9 from "../../assets/surveySlider/IMG_0760.MOV";
import VideoFile10 from "../../assets/surveySlider/IMG_0761.MOV";
import VideoFile11 from "../../assets/surveySlider/IMG_0762.MOV";
import VideoFile12 from "../../assets/surveySlider/IMG_8601.MOV";
import VideoFile13 from "../../assets/surveySlider/IMG_7374.MOV";
import VideoFile14 from "../../assets/surveySlider/IMG_5508.MOV";
import VideoFile15 from "../../assets/surveySlider/IMG_5457.MOV";
import VideoFile16 from "../../assets/surveySlider/IMG_3806.MOV";
import VideoFile17 from "../../assets/surveySlider/IMG_3805.MOV";
// Превьюшки
import Poster1 from "../../assets/surveySlider/posters/IMG_0705.jpg";
import Poster2 from "../../assets/surveySlider/posters/IMG_0719.jpg";
import Poster3 from "../../assets/surveySlider/posters/IMG_0728.jpg";
import Poster4 from "../../assets/surveySlider/posters/IMG_0733.jpg";
import Poster5 from "../../assets/surveySlider/posters/IMG_0734.jpg";
import Poster6 from "../../assets/surveySlider/posters/IMG_0735.jpg";
import Poster7 from "../../assets/surveySlider/posters/IMG_0737.jpg";
import Poster8 from "../../assets/surveySlider/posters/IMG_0738.jpg";
import Poster9 from "../../assets/surveySlider/posters/IMG_0760.jpg";
import Poster10 from "../../assets/surveySlider/posters/IMG_0761.jpg";
import Poster11 from "../../assets/surveySlider/posters/IMG_0762.jpg";
import Poster12 from "../../assets/surveySlider/posters/IMG_8601.jpg";
import Poster13 from "../../assets/surveySlider/posters/IMG_7374.jpg";
import Poster14 from "../../assets/surveySlider/posters/IMG_5508.jpg";
import Poster15 from "../../assets/surveySlider/posters/IMG_5457.jpg";
import Poster16 from "../../assets/surveySlider/posters/IMG_3806.jpg";
import Poster17 from "../../assets/surveySlider/posters/IMG_3805.jpg";
import SurveyCard from "./SurveyCard";

// Кастомные стрелки
const CustomArrow = ({ direction, onClick }: { direction: "left" | "right"; onClick?: () => void }) => {
    return (
        <button
            onClick={onClick}
            // className={`absolute top-1/2 transform -translate-y-1/2 bg-white rounded-full shadow p-2 ${direction === "left" ? "left-0" : "right-0"
            //     }`}
            style={{ zIndex: 10 }}
        >
            {direction === "left" ? (
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 12.4941H5M5 12.4941L12 19.4941M5 12.4941L12 5.49414" stroke="#1E1E1E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            ) : (
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 12.4941H19M19 12.4941L12 5.49414M19 12.4941L12 19.4941" stroke="#1E1E1E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            )}
        </button>
    );
};

const SurveySlider = () => {
    const sliderRef = useRef<Slider | null>(null);

    const surveys = useMemo(() => [
        { id: 1, videoUrl: VideoFile1, poster: Poster1 },
        { id: 2, videoUrl: VideoFile2, poster: Poster2 },
        { id: 3, videoUrl: VideoFile3, poster: Poster3 },
        { id: 4, videoUrl: VideoFile4, poster: Poster4 },
        { id: 5, videoUrl: VideoFile5, poster: Poster5 },
        { id: 6, videoUrl: VideoFile6, poster: Poster6 },
        { id: 7, videoUrl: VideoFile7, poster: Poster7 },
        { id: 8, videoUrl: VideoFile8, poster: Poster8 },
        { id: 9, videoUrl: VideoFile9, poster: Poster9 },
        { id: 10, videoUrl: VideoFile10, poster: Poster10 },
        { id: 11, videoUrl: VideoFile11, poster: Poster11 },
        { id: 12, videoUrl: VideoFile12, poster: Poster12 },
        { id: 13, videoUrl: VideoFile13, poster: Poster13 },
        { id: 14, videoUrl: VideoFile14, poster: Poster14 },
        { id: 15, videoUrl: VideoFile15, poster: Poster15 },
        { id: 16, videoUrl: VideoFile16, poster: Poster16 },
        { id: 17, videoUrl: VideoFile17, poster: Poster17 },
      ], []);      

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 2 } },
            { breakpoint: 768, settings: { slidesToShow: 2 } },
            { breakpoint: 480, settings: { slidesToShow: 1 } },
        ],
    };

    return (
        <div className="container mx-auto px-4 py-8">
            <div className="relative flex justify-between items-center mb-4">
                <h2 className="text-2xl font-bold">Обзоры от Vanil</h2>
                <div className="flex space-x-2">
                    <CustomArrow direction="left" onClick={() => sliderRef.current?.slickPrev()} />
                    <CustomArrow direction="right" onClick={() => sliderRef.current?.slickNext()} />
                </div>
            </div>

            <Slider {...settings} ref={sliderRef}>
                {surveys.map((survey) => (
                    <div key={survey.id} className="p-4 w-[350px] flex-none">
                        <SurveyCard survey={survey} />
                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default SurveySlider;